export const EMAIL_PREVIEW_MODAL_CLASSNAME = "w-[600px] max-w-[95vw]";
